export const headers = [
  {
    headerName: 'Número',
    field: 'simingresonumero',
    width: 150,
  },
  {
    headerName: 'Usuario',
    field: 'nombreUsuarioCompleto',
  },
  {
    headerName: 'Fecha y Hora Ingreso',
    field: 'simingresofecha_alta',
    width: 300,
  },
  {
    headerName: 'Reporte Carga',
    field: 'numeroreportesim',
    width: 150,
  },
  {
    headerName: 'Reporte CRM',
    field: 'reporte_crm',
    width: 150,
  },
  {
    headerName: 'CRM Estado',
    field: 'ingresocrm_estado',
    width: 150,
  },
  {
    headerName: 'Estado',
    field: 'simingresoestadoColor',
  },
  {
    headerName: 'Cantidad SIM Archivo',
    field: 'simingresocant',
  },
  {
    headerName: 'Cantidad SIM Cargadas',
    field: 'simingresocant_cargada',
  },
  {
    headerName: 'Telco',
    field: 'telconame',
  },
  {
    headerName: 'Plan',
    field: 'telcoplanname',
    width: 400,
  },
  {
    headerName: 'Destino',
    field: 'tipoubicaname',
  },
];
